import React from "react";
import { TableRow, TableCell } from "@mui/material";
import DragHandle from "./DragHandle";

export const DragColumnHeader = ({ enabled }) =>
  enabled ? <TableCell sx={{ width: 40 }} /> : null;

const ReorderableTableRow = ({
  id,
  dragEnabled,
  onDragStart,
  onDragOver,
  onDrop,
  children,
  ...props
}) => (
  <TableRow
    {...props}
    onDragOver={dragEnabled ? onDragOver : undefined}
    onDrop={dragEnabled ? () => onDrop(id) : undefined}
  >
    {dragEnabled && (
      <TableCell sx={{ width: 40, paddingX: 1 }}>
        <DragHandle onDragStart={onDragStart} id={id} />
      </TableCell>
    )}
    {children}
  </TableRow>
);

export default ReorderableTableRow;
